/**
 * UI handler utilities for canvas template
 * Extracted from AddCanvasTemplate.js to reduce file size
 */

/**
 * Handle sorting for table columns
 * @param {string} key - Column key to sort by
 * @param {Object} sortConfig - Current sort configuration
 * @param {Function} setSortConfig - Function to update sort configuration
 * @returns {Object} New sort configuration
 */
export const handleSort = (key, sortConfig, setSortConfig) => {
  let direction = "ascending";
  if (sortConfig.key === key && sortConfig.direction === "ascending") {
    direction = "descending";
  }
  const newConfig = { key, direction };
  setSortConfig(newConfig);
  return newConfig;
};

/**
 * Show snackbar notification
 * @param {string} message - Message to display
 * @param {string} type - Snackbar type (success, error, etc.)
 * @param {Function} setSnackbar - Function to update snackbar state
 */
export const showSnackbar = (message, type, setSnackbar) => {
  setSnackbar({ open: true, message, type });
};

/**
 * Close snackbar notification
 * @param {Object} snackbar - Current snackbar state
 * @param {Function} setSnackbar - Function to update snackbar state
 */
export const handleCloseSnackbar = (snackbar, setSnackbar) => {
  setSnackbar({ ...snackbar, open: false });
};

/**
 * Close modal
 * @param {Function} setShowModal - Function to update modal visibility state
 */
export const handleCloseModal = (setShowModal) => {
  setShowModal(false);
};

/**
 * Wrapper for generateSnapshotFromResponse that also updates canvas elements state
 * @param {Object} elements - Canvas elements
 * @param {Function} setCanvasElements - Function to update canvas elements state
 * @param {Function} generateSnapshotFromResponse - Function to generate snapshot
 * @returns {Promise<string>} Generated snapshot
 */
export const generateSnapshotFromResponseWithState = async (
  elements,
  setCanvasElements,
  generateSnapshotFromResponse
) => {
  setCanvasElements(elements);
  return generateSnapshotFromResponse(elements);
};

